import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import { api } from "../../lib/api";

export default function AdminMessages() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/messages")
            .then((r) => setList(r.data || []))
            .catch(() => setList([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <AdminLayout>
            <div className="p-6 lg:p-10">
                <h1 className="font-display text-3xl text-brand-navy mb-8">Messages</h1>
                <div className="bg-white border border-gray-100 divide-y divide-gray-100" data-testid="admin-messages-list">
                    {loading ? (
                        <div className="p-10 text-center text-gray-500">Chargement…</div>
                    ) : list.length === 0 ? (
                        <div className="p-10 text-center text-gray-500">Aucun message.</div>
                    ) : (
                        list.map((m) => (
                            <div key={m.id} className="p-5">
                                <div className="flex flex-wrap items-center justify-between gap-3">
                                    <div>
                                        <div className="font-semibold text-brand-navy">{m.name}</div>
                                        <div className="text-xs text-gray-500">{m.email}{m.phone ? ` · ${m.phone}` : ""}</div>
                                    </div>
                                    <div className="text-xs text-gray-400">{new Date(m.created_at).toLocaleString()}</div>
                                </div>
                                {m.subject ? <div className="mt-2 text-sm font-semibold text-brand-emerald">{m.subject}</div> : null}
                                <p className="mt-2 text-sm text-gray-700 whitespace-pre-line">{m.message}</p>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </AdminLayout>
    );
}
